import type {GroupData} from 'src/types/groups';
import type {Group, ShareableGroup} from 'src/action-creators/groups';


export const getGroupCreationWarningData = (
  t: (arg1: string, arg2: string) => string,
  showWarnings: boolean = true,
): {
  onAction?:
    | ((arg1: React.SyntheticEvent<HTMLElement>) => unknown)
    | null
    | undefined;
  actionText?: string;
  warningMessage?: string;
  isSecurityGroup?: boolean;
  informationMessage?: string;
} => {
  return {
    actionText: t('Learn_More', 'Learn More'),
    warningMessage: t(
      'This_action_is_not_recommended_You_are_about_to_create_a_security_group_with_all_the_candidates_which_could_lead_to_experience_degradation_for_you_as_well_as_others',
      'This action is not recommended. You are about to create a security group with all the candidates which could lead to experience degradation for you as well as others.',
    ),
    informationMessage: t(
      'Security_group_is_not_created_yet_Please_add_rules_to_create_security_group',
      'Security group is not created yet. Please add rules to create security group.',
    ),
    onAction: () =>
      window.open(
        'https://support.sensehq.co/hc/en-us/articles/46291948424205-Security-Groups-UI-Enhancements',
        '_blank',
      ),
    isSecurityGroup: showWarnings,
  };
};

export const getGroupAndDescendants = <T extends Group | ShareableGroup>(
  groups: T[],
  groupId: string,
): T[] => {
  const result: Array<T> = [];
  const group = groups.find((group) => group.id === groupId);

  if (!group) {
    return result;
  }

  result.push(group);

  // Keeps adding children to the end of the array and descending into
  // each of those children and adding their children to end of array and
  // descending etc until all descendants have been found. Basically a
  // breadth-first search.
  for (let i = 0; i < result.length; i++) {
    const parent = result[i];
    const children = groups.filter(
      (child) => child.parentSecurityGroupId === parent.id,
    );
    result.push(...children);
  }

  return result;
};

export const rootGroupId = (groupData: {[id: string]: Group}): string => {
  // finds the group whose parent property is either null or
  // outside the seen collection (see group-utils-tests.js)
  const groupIds = Object.keys(groupData);
  // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
  return groupIds.find(
    (id) => !groupIds.includes(groupData[id].parentSecurityGroupId),
  );
};

export const checkSecurityGroupNameValid = (
  allGroups: Array<GroupData> | Array<Group>,
  name: string,
): boolean => {
  // Check if any group already has the same name
  return !allGroups.some(
    (group) => group.name.toLowerCase() === name.toLowerCase(),
  );
};
